const InteractiveMapHandler = (
  stateInteractiveMap,
  setInteractiveMap,
  onCountryClick,
  onCountryHover,
  onMoveEnd
) => {
  return {
    handleMouseEnter: (geo) => {
      setInteractiveMap("hoveredCountry", geo.id);
      if (onCountryHover) {
        onCountryHover({
          id: geo.id,
          name: geo.properties.name,
          geometry: geo.geometry,
        });
      }
    },

    handleMouseLeave: () => {
      setInteractiveMap("hoveredCountry", null);
      if (onCountryHover) {
        onCountryHover(null);
      }
    },

    handleClick: (geo) => {
      setInteractiveMap("selectedCountry", geo.id);
      if (onCountryClick) {
        onCountryClick({
          id: geo.id,
          name: geo.properties.name,
        });
      }
    },

    handleMoveEnd: (position) => {
      if (onMoveEnd) {
        onMoveEnd(position);
      }
    },

    getFillColor: (isHighlighted, isHovered) => {
      if (isHovered && isHighlighted) {
        return "#DE5C8E"; // Primary color
      }
      if (isHighlighted) {
        return "#F4C2D7"; // Primary light
      }
      if (isHovered) {
        return "#6e6e6e"; // Border color
      }
      return "#b5b3b3"; // Background color
    },

    getHoverColor: (isHighlighted) => {
      if (isHighlighted) {
        return "#DE5C8E"; // Primary color
      }
      return "#E0E0E0"; // Border color
    },
  };
};

export default InteractiveMapHandler;
